module.exports = __webpack_public_path__ + "static/media/logout.904ff53a.svg";